import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_step_arrow_1",
  "use": "lc_step_arrow_1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_step_arrow_1\"><defs><style type=\"text/css\"></style></defs><path d=\"M122.662179 958.685435 393.247874 503.449253 122.662179 62.365396l775.767406 448.097598L122.662179 958.685435 122.662179 958.685435zM122.662179 958.685435\" p-id=\"1099\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol